<template>
  <div class="qr-code-form">
    <div id="login_container" />
    <span>请使用飞书扫码登录 <a @click="onBack">返回</a></span>
  </div>
</template>
<script>
import '@/utils/WebQRCode-1.0.1.js';
export default {
  data() {
    return {
      code: this.$route.query.code || null,
      QRLoginObj: '',
      goto: null
    };
  },
  computed: {
    redirectUri() {
      if (this.$router.currentRoute.query.url) {
        return `${process.env.VUE_APP_FS_REDIRECT_URI}?url=${this.$router.currentRoute.query.url}`;
      }
      return process.env.VUE_APP_FS_REDIRECT_URI;
    }
  },
  created() {
    this.goto = `${process.env.VUE_APP_FS_BASE_URL}?client_id=${process.env.VUE_APP_FS_CLIENT_ID}&redirect_uri=${this.redirectUri}&response_type=code&state=STATE`;
  },
  mounted() {
    this.QRLoginObj = window.QRLogin({
      id: 'login_container',
      goto: this.goto,
      width: '260',
      height: '260',
      style: 'border: 0'
    });

    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('message', this.handleMessage, false);
    } else if (typeof window.attachEvent !== 'undefined') {
      window.attachEvent('onmessage', this.handleMessage);
    }
  },
  methods: {
    onBack() {
      this.$emit('back');
    },
    handleMessage(event) {
      var origin = event.origin;
      // 使用 matchOrigin 方法来判断 message 是否来自飞书页面
      if (this.QRLoginObj.matchOrigin(origin)) {
        var loginTmpCode = event.data;
        // 在授权页面地址上拼接上参数 tmp_code，并跳转
        window.location.href = `${this.goto}&tmp_code=${loginTmpCode}`;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.qr-code-form {
  width: 260px;
  margin: 0px auto;
  text-align: center;
}

.login-form_title {
  font-size: 1.275rem;
  line-height: 2.25rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
}
</style>
